module.exports = "/_next/static/images/strategic-planning-training-service-1-fcdde99d84a346f3d7bc52986da8638f.webp";